import { Icon } from '@iconify/react';
import FieldPickerMenu from '@/components/admin/booking/FieldPickerMenu';
import type { CalendarField } from '@/services/bookingCalendarService';
import type { CalendarView } from '@/components/admin/booking/useBookingCalendar';
import { cn } from '@/lib/utils';

interface BookingToolbarProps {
  title?: string;
  rangeLabel: string;
  view: CalendarView;
  fields: CalendarField[];
  fieldSlug: string | null;
  onShift: (direction: number) => void;
  onToday: () => void;
  onView: (view: CalendarView) => void;
  onField: (slug: string | null) => void;
  onMode?: (field: CalendarField, mode: CalendarField['availability_mode']) => void;
  onAdd?: () => void;
}

export default function BookingToolbar(props: BookingToolbarProps) {
  return (
    <div className="pb-4">
      {/* Date Navigator & Filter / View Toggles */}
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        {/* Left: Date Navigator */}
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => props.onShift(-1)}
            aria-label="Sebelumnya"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E0E6ED] bg-white text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
          >
            <Icon icon="ph:caret-left-bold" className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={props.onToday}
            className="h-10 rounded-full border border-[#E0E6ED] bg-white px-4 text-sm font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
          >
            Hari ini
          </button>
          <button
            type="button"
            onClick={() => props.onShift(1)}
            aria-label="Sesudahnya"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E0E6ED] bg-white text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
          >
            <Icon icon="ph:caret-right-bold" className="h-4 w-4" />
          </button>
          <span className="ml-2 text-base font-semibold text-[#0E1726]">{props.rangeLabel}</span>
        </div>

        {/* Right: Field Picker + View Segmented Toggle (Harian / Mingguan only) */}
        <div className="flex flex-wrap items-center gap-3">
          <FieldPickerMenu fields={props.fields} selectedSlug={props.fieldSlug} onSelect={props.onField} />

          <div className="flex items-center rounded-full border border-[#E0E6ED] bg-[#F5F6F7] p-1">
            <button
              type="button"
              className={cn(
                'rounded-full px-4 py-1.5 text-xs font-semibold transition-all sm:text-sm',
                props.view === 'day'
                  ? 'bg-white text-[#FC480D] shadow-sm'
                  : 'text-gray-500 hover:text-gray-900'
              )}
              onClick={() => props.onView('day')}
            >
              Harian
            </button>
            <button
              type="button"
              className={cn(
                'rounded-full px-4 py-1.5 text-xs font-semibold transition-all sm:text-sm',
                props.view === 'week'
                  ? 'bg-white text-[#FC480D] shadow-sm'
                  : 'text-gray-500 hover:text-gray-900'
              )}
              onClick={() => props.onView('week')}
            >
              Mingguan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
